import React from 'react';
import { getSubdomain } from '../../helpers/utils';

const StepCounter = ({ currentStep }) => {
  const partnerSlug = getSubdomain();
  const isBridgehomes = partnerSlug === 'bridgehomes';

  return (
    <div className="step">
      {`Step ${currentStep}/${isBridgehomes ? 4 : 5}`}
    </div>
  );
};

export default StepCounter;
